"use client";

import { useEffect, useCallback } from "react";
import { useLocalStorage } from "./use-local-storage";
import { STORAGE_KEYS } from "@/lib/constants";

type Theme = "light" | "dark";

export function useTheme() {
  const [theme, setTheme, isHydrated] = useLocalStorage<Theme>(STORAGE_KEYS.THEME, "light");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  }, [theme]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const storedTheme = localStorage.getItem(STORAGE_KEYS.THEME);

    if (!storedTheme) {
      setTheme(mediaQuery.matches ? "dark" : "light");
    }
  }, [setTheme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  }, [setTheme]);

  return { theme, setTheme, toggleTheme, isHydrated };
}
